<template>
    <div>
        <div class="flex flex-col">
            <div
                id="title-general"
                class="flex flex-col md:flex-row justify-between items-center"
            >
                <div class="flex justify-between items-center">
                    <router-link
                        to="/app/cash-outputs"
                        class="rounded-full bg-brand-blue flex justify-center items-center p-2"
                    >
                        <span>🏠</span>
                    </router-link>
                    <div class="ml-3">
                        <h1 class="text-3xl text-theme-base">
                            {{
                                (itemComponent.merchant &&
                                    itemComponent.merchant.name) ||
                                "Gasto"
                            }}
                        </h1>
                        <p class="text-sm text-theme-muted mt-1">#{{ id }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="loadedAllData" id="bill-features">
            <div class="flex flex-wrap">
                <div v-if="id" class="w-full mt-3 p-0 flex">
                    <span>
                        Fecha de creación 📆💾
                        {{ itemComponent.createdAt | date }}
                    </span>
                </div>
            </div>

            <div class="flex flex-wrap">
                <div class="w-full md:w-1/2 px-2">
                    <custom-input
                        v-model="itemComponent.merchant.name"
                        :label="
                            itemComponent.merchant.type
                                | merchantInfo('type')
                                | transformString('capitalize')
                        "
                        disabled
                    />
                </div>
                <div class="w-full md:w-1/2 px-2">
                    <custom-input
                        v-model="itemComponent.user.email"
                        label="Registrado por"
                        disabled
                    />
                </div>
                <div class="w-full md:w-1/2 px-2">
                    <custom-input
                        v-model="itemComponent.concept"
                        label="Concepto"
                        disabled
                    />
                </div>
                <div class="w-full md:w-1/2 mt-6 px-2">
                    <supplier-selector
                        :item-current="{
                            name: itemComponent.provider || '',
                            slug: ''
                        }"
                        :enabled="false"
                    />
                </div>
                <div class="w-full md:w-1/2 mt-6 px-2">
                    <input-money-component
                        v-model="itemComponent.value"
                        label="Valor"
                        :enabled="false"
                    />
                </div>
                <div class="w-full md:w-1/2 mt-6 px-2">
                    <input-money-component
                        v-model="itemComponent.valuePaid"
                        label="Valor pagado"
                        :enabled="false"
                    />
                </div>
            </div>

            <div v-if="itemComponent.receiptFile" class="flex flex-wrap mt-3">
                <div class="w-full flex">
                    <button class="btn btn-stack-primary">
                        Descargar comprobante de pago
                        {{ itemComponent.receiptFile.name }}
                    </button>
                </div>
            </div>

            <div
                v-if="itemComponent.inputs.length > 0"
                class="flex flex-wrap z-0 mt-3 mb-4 min-h-32"
            >
                <div class="w-full">
                    <h4 class="mt-3">Variantes ingresadas al inventario</h4>
                    <reference-inventory-items
                        v-for="(reference, index) in itemComponent.inputs"
                        :key="'A' + index"
                        :enabled="false"
                        class="md:w-11/12 w-full mx-auto"
                        :reference="reference"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { EMPTY_MONEY_CONFIG } from "@/common/lib/money";

import ReferenceInventoryItems from "@/components/references/ReferenceInventoryItems.vue";
import SupplierSelector from "@/components/suppliers/SupplierSelector.vue";
import CustomInput from "@/components/utils/CustomInput.vue";
import InputMoneyComponent from "@/components/utils/InputMoneyComponent.vue";

export default {
    name: "CashOutputDetail",
    components: {
        InputMoneyComponent,
        ReferenceInventoryItems,
        SupplierSelector,
        CustomInput
    },
    data: () => ({
        id: 0,
        isLoading: false,
        loadedAllData: false,
        enabledUpdate: false,
        itemComponent: {
            id: 3,
            value: 845,
            valuePaid: 845,
            concept: "",
            provider: "",
            createdAt: "2023-04-10T01:51:38.015Z",
            moneyConfig: EMPTY_MONEY_CONFIG,
            receiptFile: { url: "", name: "" },
            inputs: [],
            user: {
                id: "b8529984-56ab-4783-9fa9-a14fd7ce9a06",
                email: "innovalombia@gmail.com"
            },
            merchant: {
                id: "c444962d-4c2e-42fa-bc43-600cfe10cebd",
                name: "Timiza",
                type: "store"
            }
        }
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"])
    },
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        if (
            !(await verifyPagePermission("cashOutput:Get", "/app/cash-outputs"))
        )
            return;
        const id = Number(this.$route.params.id);
        this.id = id;
        await this.getBaseCashOutput({
            id,
            merchantId: this.$route.query.merchantId,
            merchantType: this.$route.query.merchantType
        });
    },
    methods: {
        ...mapActions("cashOutput", ["getCashOutputById"]),
        async getBaseCashOutput({ id, merchantId, merchantType }) {
            this.isLoading = true;
            this.$loading.show();
            try {
                this.itemComponent = await this.getCashOutputById({
                    id,
                    merchantId,
                    merchantType
                });
                this.loadedAllData = true;
                this.isLoading = false;
                this.$loading.hide();
            } catch (error) {
                this.isLoading = false;
                this.$loading.hide();
                this.$sound.play("error");
                this.$loading.hide();
                await this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
                if (error.statusCode === 404) {
                    this.$router.push("/app/cash-outputs");
                }
            }
        }
    }
};
</script>
